// extracted by mini-css-extract-plugin
module.exports = {"Translation":"Translation___2C_Y7","translation-text":"translation-text___dLe9B","google-translate":"google-translate___2x68s","translation-btn":"translation-btn___nLGKa"};